import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/InfluencerCampaignSummary.graphql';
import { Query, QueryinfluencerCampaignSummaryArgs } from '../../__generated__/globalTypes';

export const useInfluencerCampaignSummaryQuery = (
  options?: QueryHookOptions<Query, QueryinfluencerCampaignSummaryArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryinfluencerCampaignSummaryArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useInfluencerCampaignSummaryLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryinfluencerCampaignSummaryArgs>
): QueryResult<Query, QueryinfluencerCampaignSummaryArgs> & {
  getInfluencerCampaignSummary: LazyQueryExecFunction<Query, QueryinfluencerCampaignSummaryArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getInfluencerCampaignSummary, result] = useLazyQuery<Query, QueryinfluencerCampaignSummaryArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getInfluencerCampaignSummary, ...result };
};

export const useInfluencerCampaignSummaryPromiseQuery = () => {
  const client = useApolloClient();

  const getInfluencerCampaignSummary = useCallback(
    (options?: Omit<QueryOptions<QueryinfluencerCampaignSummaryArgs, Query>, 'query'>) =>
      client.query<Query, QueryinfluencerCampaignSummaryArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getInfluencerCampaignSummary };
};
// Suspense Query Hooks
export const useInfluencerCampaignSummarySuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryinfluencerCampaignSummaryArgs>
) => {
  const result = useSuspenseQuery<Query, QueryinfluencerCampaignSummaryArgs>(QUERY, {
    ...options
  });

  return result;
};
